// When the field view fits the map to its fields: as it opens (the map mounts in it, or the screen turns to it).
// A field opened from the dashboard reaches the viewer before the fields layer, which waits for the viewer's own
// data: opened without it, the fit waits for the first update that draws the fields. Only once, so later updates
// leave the user's pan and zoom alone; leaving the field view drops a fit still waiting.
export const getFieldViewFit = ({ isFieldView, wasFieldView, isFitPending, hasFieldsLayer, hasFields }) => {
  const isFitDue = !!isFieldView && (!wasFieldView || !!isFitPending)
  return {
    shouldFit: isFitDue && !!hasFields,
    // Not for a layer already there but still empty (the viewer's own list): it redraws right after the map, and
    // the map's seasons-extent fit already follows that redraw. Waiting too would fit twice.
    isFitPending: isFitDue && !hasFields && (!!isFitPending || !hasFieldsLayer)
  }
}

// An empty OpenLayers extent starts at Infinity (the guard of the map's zoomToLayer): nothing to fit to.
export const hasExtent = extent => !!extent && extent[0] !== Infinity
